export default __webpack_public_path__ + "static/media/006-Deadpool.da00be05.svg";